document.addEventListener("DOMContentLoaded", function() {
  const header = document.querySelector('#shopify-section-header');
  const announcementBar = document.querySelector('#shopify-section-announcement-bar');
  const sidebar = document.querySelector('.fit-guide-side-bar__container-inner');
  if (!sidebar) return;

  const SIDEBAR_FIXED_HEIGHT = 500; // px
  let ticking = false;

  function getActiveSection() {
    const sections = Array.from(document.querySelectorAll('.shopify-section'));
    return sections.find(
      (sec) =>
        !sec.classList.contains('fit-guide-hidden') &&
        sec.querySelector('.fit-element')
    );
  }

  function updateSidebarTop() {
    const headerHeight = header ? header.offsetHeight : 0;
    const announceHeight = announcementBar ? announcementBar.offsetHeight : 0;

    const activeSection = getActiveSection();
    if (!activeSection) {
      // Pages like Size Guide may have the sidebar without .fit-element content.
      computeOffset();
      return;
    }

    const fitElement = activeSection.querySelector('.fit-element');
    if (!fitElement || !header) {
      computeOffset();
      return;
    }

    const headerRect = header.getBoundingClientRect();
    const elementRect = fitElement.getBoundingClientRect();
    const distance = elementRect.top - headerRect.bottom;

    const parent = sidebar.parentElement;
    if (parent) {
      parent.style.setProperty('--rich-text-height', `${distance}px`);
    }

    const totalOffset = headerHeight + announceHeight + distance;
    sidebar.style.top = `${totalOffset}px`;
  }


  function computeOffset() {
    const headerHeight = header ? header.offsetHeight : 0;
    const announceHeight = (announcementBar && window.scrollY === 0)
      ? announcementBar.offsetHeight
      : 0;

    const totalOffset = headerHeight + announceHeight;

    // Set top offset if changed
    if (sidebar._lastOffset !== totalOffset) {
      sidebar.style.top = `${totalOffset}px`;
      sidebar._lastOffset = totalOffset;
    }

    // Set a fixed height (no dynamic calc)
    if (sidebar._heightSet !== true) {
      sidebar._heightSet = true;
    }

  }

  function rafUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      computeOffset();
      ticking = false;
    });
  }

  updateSidebarTop();
  // Initial
  computeOffset();

  // Updates
  window.addEventListener('scroll', rafUpdate, { passive: true });
  window.addEventListener('resize', rafUpdate);

  // Theme editor events
  document.addEventListener('shopify:section:load', computeOffset);
  document.addEventListener('shopify:section:reorder', computeOffset);

  const links = document.querySelectorAll(".fit-guide-side-bar__link");
  if (!links.length) return;
  const currentUrl = window.location.origin + window.location.pathname + window.location.search;
  console.log(currentUrl)

  links.forEach((link) => {
    const linkUrl = link.href;
    const normalizedCurrent = currentUrl.replace(/\/$/, "");
    const normalizedLink = linkUrl.replace(/\/$/, "");
    if (normalizedCurrent === normalizedLink) {
      link.setAttribute("aria-selected", "true");
    } else {
      link.removeAttribute("aria-selected");
    }
  });

  const sidebarEl = document.querySelector('.fit-guide-side-bar__container');
  if (sidebarEl) {
    sidebarEl.addEventListener('click', (e) => {
      const tab = e.target.closest('p[data-start][data-end]');
      if (!tab) return;
      setTimeout(() => {
        updateSidebarTop();
      }, 150);
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const sidebar = document.querySelector('.fit-guide-side-bar__container');
  if (!sidebar) return;

  const thisSection = sidebar.closest('.shopify-section');
  if (!thisSection) return;

  const EXCLUDE_IDS = new Set([
    'shopify-section-header',
    'shopify-section-announcement-bar',
    'shopify-section-footer',
    'shopify-section-template--18697714761797__page_banner_qmDgEr',
    thisSection.id
  ]);

  function getOrderedSections() {
    const all = Array.from(document.querySelectorAll('.shopify-section'));
    return all.filter(sec => !EXCLUDE_IDS.has(sec.id));
  }

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function showRange(start, end) {
    const sections = getOrderedSections();
    if (!sections.length) return;

    let s = parseInt(start, 10);
    let e = parseInt(end, 10);
    if (Number.isNaN(s) || Number.isNaN(e)) return;

    if (e < s) { const tmp = s; s = e; e = tmp; }
    s = clamp(s, 1, sections.length);
    e = clamp(e, 1, sections.length);

    // sections.forEach((sec, idx) => {
    //   const pos = idx + 1;
    //   if (pos >= s && pos <= e) {
    //     sec.classList.remove('fit-guide-hidden');
    //   } else {
    //     sec.classList.add('fit-guide-hidden');
    //   }
    // });
  }

  function onSidebarClick(e) {
    const target = e.target.closest('p[data-start][data-end]');
    if (!target) return;

    const start = target.getAttribute('data-start');
    const end = target.getAttribute('data-end');
    showRange(start, end);

    sidebar.querySelectorAll('p[data-start][data-end]').forEach(p => p.setAttribute('aria-selected', 'false'));
    target.setAttribute('aria-selected', 'true');
  }

  (function initFromSectionSettings() {
    const start = sidebar.getAttribute('data-start');
    const end = sidebar.getAttribute('data-end');
    if (start && end) {
      showRange(start, end);
      const match = sidebar.querySelector(`p[data-start="${start}"][data-end="${end}"]`);
      if (match) match.setAttribute('aria-selected', 'true');
    }
  })();

  sidebar.addEventListener('click', onSidebarClick);

  document.addEventListener('shopify:section:load', () => {
    const active = sidebar.querySelector('p[aria-selected="true"]');
    if (active) {
      showRange(active.getAttribute('data-start'), active.getAttribute('data-end'));
    } else {
      const s = sidebar.getAttribute('data-start');
      const e = sidebar.getAttribute('data-end');
      if (s && e) showRange(s, e);
    }
  });

  document.addEventListener('shopify:section:reorder', () => {
    const active = sidebar.querySelector('p[aria-selected="true"]');
    if (active) showRange(active.getAttribute('data-start'), active.getAttribute('data-end'));
  });
});